import {Card, styled} from '@mui/material';
import {StyledCardProps} from './types';

const StyledCard = styled(Card)<StyledCardProps>`
	border-radius: 8px;
	border: 2px solid transparent;
	cursor: ${({$isCursorPointer}) => ($isCursorPointer ? 'pointer' : 'default')};
	background: ${({$isAdvanceUnit}) =>
		$isAdvanceUnit
			? 'linear-gradient(white, white) padding-box, linear-gradient(296deg, #1539aa 13.42%, #00a6ff 75.86%, #0944ff 92.09%) border-box'
			: 'white'};
	padding: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export {StyledCard};
